import React from 'react';

const WhyDecimalSection = () => {
  const benefits = [
    {
      icon: 'ri-seedling-line',
      title: 'Talent Pathways',
      description:
        'Build clear development routes that nurture potential and create future stars for your organisation',
    },
    {
      icon: 'ri-pulse-line',
      title: 'Performance Culture',
      description:
        'Embed excellence into your DNA with systems that drive consistent high performance across teams',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Sponsorship Growth',
      description:
        'Unlock commercial opportunities through strategic partnerships and professional brand positioning',
    },
    {
      icon: 'ri-plant-line',
      title: 'Sustainable Development',
      description:
        'Create long‑term success with people‑first strategies that balance performance and wellbeing',
    },
  ];

  /** 
   * Navigate to the given path.
   * Uses a custom global navigation function if it exists,
   * otherwise falls back to a standard location change.
   */
  const handleClick = () => {
    try {
      if (typeof (window as any).REACT_APP_NAVIGATE === 'function') {
        // @ts-expect-error – global navigation helper injected at runtime
        (window as any).REACT_APP_NAVIGATE('/about');
      } else {
        // Fallback for environments where the helper is not present
        window.location.href = '/about';
      }
    } catch (err) {
      // Graceful degradation: log the error and still attempt a navigation
      console.error('Navigation error:', err);
      window.location.href = '/about';
    }
  };

  return (
    <section id="why-us" className="bg-white py-24">
      <div className="max-w-[1280px] mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] text-center mb-16">
          Why partner with us
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-left">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#0066FF] to-[#0052CC] rounded-full mb-6">
                <i className={`${benefit.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A1628] mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={handleClick}
            className="bg-[#0066FF] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#0052CC] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Discover Our Approach →
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyDecimalSection;
